var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    stroke: "#2D80FC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 1.53906H2.33333C1.91341 1.53906 1.51068 1.70588 1.21375 2.00281C0.916815 2.29974 0.75 2.70247 0.75 3.1224V14.2057C0.75 14.6257 0.916815 15.0284 1.21375 15.3253C1.51068 15.6222 1.91341 15.7891 2.33333 15.7891H13.4167C13.8366 15.7891 14.2393 15.6222 14.5363 15.3253C14.8332 15.0284 15 14.6257 15 14.2057V8.66406",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9218 1.24188C13.2367 0.926934 13.6639 0.75 14.1093 0.75C14.5547 0.75 14.9818 0.926934 15.2968 1.24188C15.6117 1.55682 15.7887 1.98398 15.7887 2.42938C15.7887 2.87478 15.6117 3.30193 15.2968 3.61688L8.1615 10.753C7.97351 10.9408 7.74128 11.0783 7.4862 11.1528L5.21174 11.8178C5.14362 11.8376 5.07141 11.8388 5.00267 11.8212C4.93393 11.8036 4.87119 11.7678 4.82101 11.7176C4.77084 11.6675 4.73507 11.6047 4.71746 11.536C4.69985 11.4673 4.70104 11.395 4.72091 11.3269L5.38591 9.05246C5.46074 8.79758 5.5985 8.56563 5.7865 8.37796L12.9218 1.24188Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0e4a7f2c9d31e38174b7ecefc7a02735.svg";
export { ForwardRef as ReactComponent };